interface EpisodeListProps {
  total: number;
  current: number;
  onChange: (ep: number) => void;
}

export default function EpisodeList({ total, current, onChange }: EpisodeListProps) {
  const episodes = Array.from({ length: total }, (_, i) => i + 1);

  return (
    <div className="bg-background-50 border border-background-200 rounded-lg overflow-hidden">
      <div className="flex items-center justify-between px-4 py-3.5 border-b border-background-200">
        <h2 className="font-heading font-bold text-foreground-950 flex items-center gap-2">
          <i className="ri-play-list-2-line text-primary-500"></i>
          剧集列表
        </h2>
        <span className="text-xs text-foreground-500">共 {total} 集</span>
      </div>

      <div className="p-4 flex gap-2 overflow-x-auto md:grid md:grid-cols-8 lg:grid-cols-6 xl:grid-cols-8 md:overflow-visible">
        {episodes.map((ep) => (
          <button
            key={ep}
            type="button"
            onClick={() => onChange(ep)}
            className={`w-12 md:w-auto shrink-0 h-10 rounded-md text-sm transition-colors cursor-pointer ${
              ep === current
                ? "bg-primary-500 text-background-50 font-semibold"
                : "bg-background-100 text-foreground-700 hover:bg-primary-50 hover:text-primary-600"
            }`}
          >
            {ep}
          </button>
        ))}
      </div>
    </div>
  );
}